import { classNamesFunction, Persona } from '@fluentui/react';
import React from 'react';
import { CoherencePersonaText } from './components/CoherencePersonaText';
var getClassNames = classNamesFunction();
export var CoherencePersonaBase = function (_a) {
    var styles = _a.styles, theme = _a.theme, text = _a.text, secondaryText = _a.secondaryText, profilePhotoSize = _a.profilePhotoSize, imageUrl = _a.imageUrl, onRenderTertiaryText = _a.onRenderTertiaryText;
    var classNames = getClassNames(styles, {
        theme: theme
    });
    return (React.createElement("div", { className: classNames.root },
        React.createElement(Persona, { hidePersonaDetails: true, size: profilePhotoSize, imageUrl: imageUrl }),
        React.createElement("div", { className: classNames.textArea },
            text ? React.createElement(CoherencePersonaText, { text: text, isTitle: true, classNames: classNames }) : null,
            secondaryText ? React.createElement(CoherencePersonaText, { text: secondaryText, classNames: classNames }) : null,
            onRenderTertiaryText ? onRenderTertiaryText() : null)));
};
//# sourceMappingURL=CoherencePersona.base.js.map